import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { CambiosComentarioFacturas } from '../Componentes/FunctionLogin.js';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 500 },
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function BasicModalDialogFacturas({ factura, proveedor, text, boton, tipo }) {
  const { t } = useTranslation("global");
  let date = new Date();
  const [open, setOpen] = React.useState(false);
  const [fechainicial, setFechainicial] = React.useState(dayjs(date.toISOString().split('T')[0]));
  const [descripcion, setDescripcion] = React.useState("");

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ borderColor: '#BD1F34', color: '#BD1F34', '&:hover': { borderColor: '#9a1829', bgcolor: 'rgba(189,31,52,0.05)' } }}
      >
        {boton}
      </Button>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" sx={{ mb: 2, fontWeight: 700 }}>
            {factura}
          </Typography>

          <form
            onSubmit={(event) => {
              event.preventDefault();
              CambiosComentarioFacturas(
                dayjs(fechainicial).format('YYYY-MM-DD'),
                descripcion,
                factura,
                proveedor
              ).then(() => {});
              setOpen(false);
            }}
          >
            <Stack spacing={2}>
              <FormControl>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled
                    label={t("global_buttons.fecha_comentario") || "Fecha de comentario"}
                    value={fechainicial}
                    onChange={(newValue) => { setFechainicial(newValue); }}
                    renderInput={(params) => <TextField {...params} size="small" />}
                  />
                </LocalizationProvider>
              </FormControl>

              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5 }}>
                  {t("global_buttons.comentario_factura") || "Comentario sobre la factura"}: {factura}
                </FormLabel>
                <TextField
                  multiline
                  minRows={2}
                  required
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  size="small"
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: '#BD1F34', '&:hover': { bgcolor: '#9a1829' } }}
              >
                {t("global_buttons.enviar") || "Enviar solicitud"}
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>
    </React.Fragment>
  );
}